import {Injectable} from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class UtileriasService {
  private key = 'YSqOpt7rr8LlIHGBkDC9';

  constructor() {
  }

  encrypt(txt: string): string {
    return CryptoJS.AES.encrypt(txt, this.key).toString();
  }

  decrypt(txtToDecrypt: string) {
    return CryptoJS.AES.decrypt(txtToDecrypt, this.key).toString(CryptoJS.enc.Utf8);
  }


  calcularDiferenciaDias(fechaInicio: string, fechaFin: string): number {
    const inicio = new Date(fechaInicio);
    const fin = new Date(fechaFin);

    // Diferencia en milisegundos
    const diferenciaMs = fin.getTime() - inicio.getTime();

    // Convertir a días
    return Math.ceil(diferenciaMs / (1000 * 60 * 60 * 24));
  }

  getFechaActual() {
    return new Date().toISOString().split('T')[0];
  }

  getColor(fechaStr: string): string {
    if (!fechaStr) {
      return '';
    }

    const hoy = new Date();
    const fecha = new Date(fechaStr);
    const diferencia = Math.ceil((fecha.getTime() - hoy.getTime()) / (1000 * 60 * 60 * 24));

    if (diferencia <= 1) {
      return 'bg-danger text-white';
    } else if (diferencia <= 10) {
      return 'bg-warning text-white';
    } else {
      return 'bg-success text-white';
    }
  }

  calcularDiferenciaDiasAlDiaDeHoy(fechaInput: string | Date): number {
    const fechaHoy = new Date();
    const fechaComparar = new Date(fechaInput);

    const msPorDia = 1000 * 60 * 60 * 24;
    const diferenciaMilisegundos = fechaComparar.getTime() - fechaHoy.getTime();

    // Usamos Math.round para obtener la diferencia más precisa
    const diferenciaDias = Math.ceil(diferenciaMilisegundos / msPorDia);

    return diferenciaDias;
  }

}
